module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-Regular-App.2e5fd42b.ttf";